import { __read, __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import { interpolateNumber } from 'd3-interpolate';
import { useMotionValue, useSpring } from 'framer-motion';
import { formatNumber, formatValue as valueFormatter, } from '@keen.io/charts-utils';
var springMotion = {
    from: 0,
    to: 1,
    velocity: 10,
    damping: 50,
};
var GaugeProgress = function (_a) {
    var progressType = _a.progressType, value = _a.value, minimum = _a.minimum, maximum = _a.maximum, typography = _a.typography, formatValue = _a.formatValue, isAutoApplied = _a.isAutoApplied;
    var initialValue = useMotionValue(minimum);
    var _b = __read(useState(minimum), 2), progressValue = _b[0], setProgressValue = _b[1];
    var spring = useSpring(initialValue, springMotion);
    useEffect(function () {
        var interpolator = interpolateNumber(minimum, value);
        spring.onChange(function (v) { return setProgressValue(Math.round(interpolator(v))); });
        initialValue.set(value);
        return function () { return spring.destroy(); };
    }, [value]);
    var fontColor = typography.fontColor, valueStyles = __rest(typography, ["fontColor"]);
    var isValidPercentageValue = !isAutoApplied &&
        typeof minimum === 'number' &&
        typeof maximum === 'number' &&
        minimum !== maximum;
    return (React.createElement("text", { fill: fontColor, textAnchor: "middle", style: valueStyles }, progressType === 'percent' ? (React.createElement(React.Fragment, null,
        isValidPercentageValue
            ? formatNumber(((progressValue - minimum) / (maximum - minimum)) * 100)
            : 100,
        React.createElement("tspan", { style: {
                fontSize: valueStyles.fontSize / 2,
            } }, "%"))) : formatValue ? (valueFormatter(progressValue, formatValue)) : (progressValue)));
};
export default GaugeProgress;
